import React from "react";

import { HStack, Stack, Text } from "@/components/ui";
import { cn } from "@/utils/cn";

import { generateText } from "../utils";

interface PlaceholderTabsProps {
  count?: number;
}

/** Fake tabs to display while data is loading. */
const PlaceholderTabs: React.FC<PlaceholderTabsProps> = ({ count = 3 }) => (
  <HStack>
    {[...Array(count)].map((_, i) => (
      <Stack
        key={i}
        justifyContent="center"
        alignItems="center"
        className={cn("w-full border-b-[3px] py-2", {
          "border-primary-200 dark:border-primary-900": i + 1 === count,
          "border-primary-100 dark:border-primary-800": i + 1 !== count,
        })}
      >
        <Text theme="placeholder">{generateText(7)}</Text>
      </Stack>
    ))}
  </HStack>
);

export default React.memo(PlaceholderTabs);
